// extracted by mini-css-extract-plugin
module.exports = {"close":"CloseFrame_close__U35FO","icon":"CloseFrame_icon__3tN_B"};